{
  "401": {
    "title": "Vous n'êtes pas autorisé à accéder à cette page.",
    "text": "Si vous pensez que ce n'est pas correct, contactez l'administrateur",
    "back_button": "Retour au tableau de bord"
  },
  "403": {
    "title": "Vous n'avez pas l'autorisation d'accéder à cette page.",
    "text": "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur.",
    "back_button": "Retour au tableau de bord"
  },
  "404": {
    "title": "Cette page n'a pas été trouvée.",
    "text": "La page demandée n'a pas pu être trouvée.",
    "back_button": "Retour au tableau de bord"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Déconnexion",
    "account": "Compte",
    "profile": "Profil",
    "hello": "Bonjour",
    "home": "Accueil",
    "loading": "Chargement...",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "close": "Fermer",
    "view": "Voir",
    "save": "Enregistrer",
    "records": "Enregistrements",
    "add": "Ajouter",
    "read": "Lire",
    "write": "Enregistrer",
    "edit": "Modifier",
    "new": "Nouveau",
    "delete": "Supprimer",
    "actions": "Actions",
    "active": "Actif",
    "inactive": "Inactif",
    "search": "Rechercher",
    "select": "Sélectionner",
    "none": "None",
    "yes": "Oui",
    "no": "Non",
    "years": "Années",
    "months": "Mois",
    "favorites": "Favoris",
    "reports": "Rapports",
    "recordsPerPage": "Enregistrements par page",
    "changePassword": "Modifier le mot de passe",
    "longDateFormat": "{years} année(s) et {months} mois",
    "importData": "Importer des données",
    "upload": "Télécharger",
    "downloadTemplate": "Télécharger le modèle",
    "selectOption": "Sélectionnez une option",
    "id": "ID",
    "translations": "Traductions",
    "or": "ou",
    "review": "Examiner",
    "approve": "Approuver",
    "reject": "Rejeter",
    "reviewComments": "Commentaires d'Examen",
    "reviewOnBehalfOf": "Examiner au nom de",
    "reviewed": "Examiné",
    "reviewedBy": "Examiné Par ",
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "skipped": "Ignoré",
    "warning": "Avertissement",
    "manager": "Gestionnaire",
    "move": "Déplacer",
    "leave": "Quitter",
    "export": "Exporter",
    "import": "Importer",
    "next": "Suivant",
    "previous": "Précédent",
    "done": "Terminé",
    "run": "Exécuter",
    "form": "Formulaire",
    "status": "Statut",
    "emailTemplate": "Modèle d'E-mail",
    "send": "Envoyer",
    "saving": "Enregistrement...",
    "saved": "Enregistré",
    "loadData": "Charger les données",
    "download": "Télécharger",
    "noData": "Aucune donnée disponible dans le tableau",
    "cropImage": "Rogner l'image",
    "selectImageToCrop": "Sélectionnez une image à recadrer",
    "selectImage": "Sélectionner une image",
    "list": "Liste",
    "group": "Groupe",
    "exportCsv": "Exporter CSV",
    "auditFields": "Champs d'audit",
    "saveDisplayOrder": "Enregistrer l'ordre d'affichage",
    "attach": "Joindre",
    "permissionActions": {
      "read": "Lire",
      "write": "Écrire",
      "delete": "Supprimer",
      "execute": "Exécuter"
    },
    "messages": {
      "personNotFound": "Personne non trouvée. Contactez l'Admin.",
      "notRegisteredSessionOnly": "Vous n'êtes pas enregistré dans JTP, cette modification ne s'appliquera donc qu'à votre session actuelle. Veuillez contacter l'administrateur pour être ajouté.",
      "formUnsavedChanges": "Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir fermer ?",
      "serverError": "Erreur du serveur. Veuillez réessayer plus tard ou contacter l'administrateur système.",
      "networkError": "Impossible de se connecter au serveur. Vérifiez votre connexion internet ou contactez l'administrateur système.",
      "forbidden": "Vous n'avez pas l'autorisation d'accéder à cette ressource. Contactez l'administrateur système si vous pensez qu'il s'agit d'une erreur.",
      "fileUploadError": "Erreur lors du téléchargement du fichier. Vérifiez le format et la taille du fichier et réessayez.",
      "fileUploadSuccessEmail": "Fichier téléchargé avec succès. Un e-mail avec le résultat de l'importation sera envoyé prochainement.",
      "failedLoadPermissions": "Échec du chargement des autorisations utilisateur. Veuillez actualiser la page ou contacter l'administrateur système.",
      "downloadingFile": "Téléchargement du fichier...",
      "fileDownloadError": "Erreur lors du téléchargement du fichier. Veuillez réessayer ou contacter l'administrateur système.",
      "fileImportedSuccessfully": "Fichier importé avec succès.",
      "invalidFileFormat": "Format de fichier invalide. Veuillez verifier le fichier et reessayer.",
      "exportFailed": "Echec de l'exportation des donnees. Veuillez reessayer ou contacter l'administrateur systeme.",
      "unableGetPermissions": "JTP n'est pas en mesure d'obtenir vos autorisations. Vous pouvez travailler avec un accès de base jusqu'à ce que ce problème soit résolu."
    },
    "warnings": {
      "maxDisplayedRecords": "Affichage de {shown} enregistrements sur {filtered}. Pour voir des enregistrements supplémentaires, utilisez la fonction de recherche."
    },
    "validation": {
      "required": "Ce champ est obligatoire.",
      "email": "Veuillez saisir une adresse e-mail valide.",
      "minValue": "La valeur doit être d'au moins {min}.",
      "maxValue": "La valeur ne peut pas être supérieure à {max}.",
      "minLength": "La valeur doit comporter au moins {min} caractères.",
      "maxLength": "La valeur ne peut pas comporter plus de {max} caractères.",
      "onlyIntegers": "La valeur doit être un nombre entier.",
      "invalidDate": "La date saisie est invalide."
    },
    "info": {
      "dragAndDropInfo": "Glissez-deposez n'importe quelle personne pour organiser l'arborescence"
    },
    "baseAuditableEntity": {
      "createdBy": "Créé par",
      "createdDate": "Date de création",
      "modifiedBy": "Modifié par",
      "modifiedDate": "Date de modification"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Interne",
      "2": "Externe"
    },
    "readinessFactor": {
      "0": "N/A",
      "1": "Prêt Maintenant",
      "2": "Prêt avec Développement (1-2 Ans)",
      "3": "Prêt avec Développement (2-3 Ans)",
      "4": "Remplacement d'Urgence"
    },
    "positionType": {
      "1": "Acheter",
      "2": "Produire",
      "3": "Vendre",
      "4": "Support"
    },
    "communicationPriority": {
      "1": "Normal",
      "2": "Haute"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Mode Pivot",
        "groups": "Groupes de Lignes",
        "rowGroupColumnsEmptyMessage": "Faites glisser ici pour définir les groupes de lignes",
        "values": "Valeurs",
        "valueColumnsEmptyMessage": "Faites glisser ici pour agréger",
        "pivots": "Étiquettes de Colonne",
        "pivotColumnsEmptyMessage": "Faites glisser ici pour définir les étiquettes de colonne",
        "columns": "Colonnes",
        "filters": "Filtres",
        "loadingOoo": "Chargement...",
        "noRowsToShow": "Aucune ligne à afficher",
        "enabled": "Activé",
        "group": "Groupe",
        "footerTotal": "Total",
        "filterOoo": "Filtrer...",
        "searchOoo": "Rechercher...",
        "blanks": "(Vides)",
        "selectAll": "(Tout Sélectionner)",
        "selectAllSearchResults": "(Sélectionner Tous les Résultats de Recherche)",
        "noMatches": "Aucune correspondance",
        "equals": "Égal à",
        "notEqual": "Différent de",
        "blank": "Vide",
        "notBlank": "Non vide",
        "lessThan": "Inférieur à",
        "greaterThan": "Supérieur à",
        "lessThanOrEqual": "Inférieur ou égal à",
        "greaterThanOrEqual": "Supérieur ou égal à",
        "inRange": "Entre",
        "inRangeStart": "De",
        "inRangeEnd": "À",
        "contains": "Contient",
        "notContains": "Ne contient pas",
        "startsWith": "Commence par",
        "endsWith": "Se termine par",
        "before": "Avant",
        "after": "Après",
        "andCondition": "ET",
        "orCondition": "OU",
        "applyFilter": "Appliquer",
        "resetFilter": "Réinitialiser",
        "clearFilter": "Effacer",
        "cancelFilter": "Annuler",
        "textFilter": "Filtre de Texte",
        "numberFilter": "Filtre de Nombre",
        "dateFilter": "Filtre de Date",
        "setFilter": "Filtre d'Ensemble",
        "pinColumn": "Épingler la Colonne",
        "pinLeft": "Épingler à Gauche",
        "pinRight": "Épingler à Droite",
        "noPin": "Ne pas Épingler",
        "valueAggregation": "Agrégation de Valeurs",
        "noAggregation": "Aucune",
        "autosizeThisColumn": "Ajuster Cette Colonne",
        "autosizeAllColumns": "Ajuster Toutes les Colonnes",
        "groupBy": "Grouper par",
        "ungroupBy": "Dégrouper par",
        "ungroupAll": "Tout Dégrouper",
        "addToValues": "Ajouter {'${variable}'} aux valeurs",
        "removeFromValues": "Retirer {'${variable}'} des valeurs",
        "addToLabels": "Ajouter {'${variable}'} aux étiquettes",
        "removeFromLabels": "Retirer {'${variable}'} des étiquettes",
        "resetColumns": "Réinitialiser les Colonnes",
        "expandAll": "Développer Tous les Groupes de Lignes",
        "collapseAll": "Réduire Tous les Groupes de Lignes",
        "copy": "Copier",
        "copyWithHeaders": "Copier avec les En-têtes",
        "copyWithGroupHeaders": "Copier avec les En-têtes de Groupe",
        "cut": "Couper",
        "paste": "Coller",
        "export": "Exporter",
        "csvExport": "Export CSV",
        "excelExport": "Export Excel",
        "sum": "Somme",
        "first": "Premier",
        "last": "Dernier",
        "min": "Min",
        "max": "Max",
        "count": "Nombre",
        "avg": "Moyenne",
        "average": "Moyenne",
        "filteredRows": "Filtrées",
        "selectedRows": "Sélectionnées",
        "totalRows": "Total des Lignes",
        "totalAndFilteredRows": "Lignes"
      },
      "noFilterMessage": "Aucun filtre pour ce rapport",
      "noAccessReport": "Vous n'avez pas accès à ce rapport. Veuillez contacter l'administrateur système si vous pensez qu'il s'agit d'une erreur.",
      "pdfSizeErrorMessage": "La taille du PDF est trop importante et ne peut pas être affichée.",
      "pdfMaxSizeDownloaded": "Le rapport est trop volumineux pour être affiché. Vérifiez votre dossier de téléchargement.",
      "failedLoadReports": "Échec du chargement des rapports. Les autres fonctionnalités fonctionneront normalement. Veuillez actualiser la page ou contacter l'administrateur système si le problème persiste.",
      "run": "Exécuter",
      "download": "Télécharger",
      "viewFilter": {
        "button": "Voir les Filtres...",
        "title": "Paramètres",
        "name": "Nom",
        "value": "Valeur"
      },
      "fullScreen": "Plein Écran...",
      "smallScreen": "Petit Écran...",
      "tabButton": {
        "fullScreen": "Masquer la section des paramètres",
        "smallScreen": "Afficher la section des paramètres",
        "about": "À propos",
        "downloadExcel": "Télécharger le fichier de feuille de calcul",
        "clear": "Fermer Tous les Onglets"
      },
      "modalAbout": {
        "title": "À propos",
        "description": "Description",
        "version": "Version",
        "reference": "Référence",
        "lastChange": "Dernier Changement",
        "dataSource": "Source de Données"
      }
    },
    "maintenance": {
      "menuName": "Rapports",
      "pageTitle": "Rapports",
      "id": "ID",
      "title": "Titre",
      "reference": "Référence",
      "directoryTree": "Arborescence",
      "directoryTreeHelp": "Utilisez un antislash pour séparer les dossiers, ex. Rapports\\Finance\\Mensuel",
      "reportType": "Type de Rapport",
      "typeGrid": "Grille",
      "typeForm": "Formulaire",
      "securityResource": "Ressource de Sécurité",
      "description": "Description",
      "versionNumber": "Version",
      "isActive": "Actif",
      "lastModified": "Dernière Modification",
      "isSchedulable": "Planifiable",
      "isArchivable": "Archivable",
      "isAuditable": "Auditable",
      "passMultiValue": "Passer les Multi-Valeurs en Chaîne",
      "expireInDays": "Expire en Jours",
      "add": "Ajouter un Rapport",
      "edit": "Modifier le Rapport",
      "delete": {
        "title": "Supprimer le Rapport",
        "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
      },
      "messages": {
        "created": "Rapport créé avec succès.",
        "updated": "Rapport sauvegardé avec succès.",
        "deleted": "Rapport supprimé avec succès.",
        "imported": "Rapport importé avec succès."
      },
      "sections": {
        "main": "Propriétés Principales",
        "parameters": "Paramètres",
        "sqls": "Instructions SQL",
        "grids": "Grilles de Résultats",
        "models": "Modèles de Rapport"
      },
      "sql": {
        "add": "Ajouter une Instruction SQL",
        "edit": "Modifier l'Instruction SQL",
        "description": "Description",
        "connection": "Connexion",
        "multipleResultset": "Ensembles de Résultats Multiples",
        "sql": "SQL",
        "generateGrids": "Générer des Grilles depuis SQL",
        "generateGridsSuccess": "Grille générée avec succès. Vérifiez-la dans l'onglet Grilles de Résultats.",
        "delete": {
          "title": "Supprimer l'Instruction SQL",
          "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
        }
      },
      "grid": {
        "add": "Ajouter une Grille",
        "edit": "Modifier la Grille",
        "label": "Libellé",
        "resultsetNumber": "N° d'Ensemble de Résultats",
        "parentGrid": "Grille Parente",
        "defaultGroupedColumns": "Colonnes Groupées par Défaut",
        "relationString": "Chaîne de Relation",
        "delete": {
          "title": "Supprimer la Grille",
          "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
        }
      },
      "column": {
        "add": "Ajouter une Colonne",
        "edit": "Modifier la Colonne",
        "columnName": "Nom de la Colonne",
        "label": "Libellé",
        "header": "En-tête",
        "dataType": "Type de Données",
        "sumarizeType": "Agrégation",
        "showOrder": "Ordre",
        "mask": "Masque",
        "helpText": "Texte d'Aide",
        "template": "Modèle",
        "delete": {
          "title": "Supprimer la Colonne",
          "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
        }
      },
      "param": {
        "add": "Ajouter un Paramètre",
        "edit": "Modifier le Paramètre",
        "displayOrder": "Ordre",
        "name": "Nom",
        "nameValidation": "Seules les lettres, chiffres et tirets bas sont autorisés.",
        "label": "Libellé",
        "dataType": "Type de Données",
        "defaultValue": "Valeur par Défaut",
        "helpText": "Texte d'Aide",
        "required": "Obligatoire",
        "multiple": "Valeurs Multiples",
        "width": "Largeur (cols)",
        "enumValues": "Valeurs (séparées par point-virgule)",
        "enumValuesHelp": "ex. 1;2;3",
        "enumLabels": "Libellés (séparés par point-virgule)",
        "enumLabelsHelp": "ex. Option A;Option B;Option C",
        "sql": "Requête SQL",
        "generate": "Générer les paramètres depuis SQL",
        "delete": {
          "title": "Supprimer le Paramètre",
          "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
        }
      },
      "model": {
        "add": "Ajouter un Modèle",
        "edit": "Modifier le Modèle",
        "description": "Description",
        "order": "Ordre",
        "connection": "Connexion",
        "file": "Fichier de Modèle (.trdx / .trdp)",
        "fileLoaded": "Fichier chargé avec succès.",
        "delete": {
          "title": "Supprimer le Modèle",
          "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
        }
      },
      "paramDataType": {
        "text": "Texte",
        "number": "Nombre",
        "date": "Date",
        "time": "Heure",
        "combo": "Combo",
        "boolean": "Booléen",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Texte",
        "number": "Nombre",
        "date": "Date",
        "time": "Heure",
        "combo": "Combo",
        "boolean": "Booléen"
      },
      "sumarizeType": {
        "nosumarize": "Aucun",
        "sum": "Somme",
        "min": "Min",
        "max": "Max",
        "average": "Moyenne",
        "count": "Nombre"
      },
      "import": {
        "connection": "Remplacement de Connexion",
        "connectionHelp": "Optionnel : remplacer toutes les références de connexion dans le fichier importé."
      }
    }
  },
  "file": {
    "description": "Description",
    "files": "Fichiers",
    "editDescription": "Modifier la Description",
    "delete": "Supprimer le Fichier",
    "download": "Télécharger le Fichier",
    "pendingUpload": "Téléchargement en attente. Le fichier ne sera enregistré qu'après avoir cliqué sur 'Enregistrer'.",
    "noFiles": "Aucun fichier ajouté."
  },
  "dashboard": {
    "menuTitle": "Tableau de Bord",
    "title": "Tableau de Bord",
    "addWidget": "Ajouter un Widget",
    "editLayout": "Modifier la Mise en Page",
    "saveLayout": "Enregistrer la Mise en Page",
    "importLayout": "Importer la Mise en Page",
    "exportLayout": "Exporter la Mise en Page",
    "category": "Catégorie",
    "widget": "Widget",
    "widgetTitle": "Titre",
    "widgetParameters": "Paramètres",
    "widgetInformation": "Informations du Widget",
    "noParameters": "Ce widget n'a aucun paramètre.",
    "delete": "Supprimer le Widget",
    "viewLink": "voir",
    "noItemsToDisplay": "Aucun élément à afficher",
    "messages": {
      "saveSuccess": "Mise en page enregistrée avec succès.",
      "importSuccess": "Mise en page importée avec succès.",
      "exportSuccess": "Mise en page exportée avec succès.",
      "importFailed": "Échec de l'importation de la mise en page.",
      "widgetNotFound": "Widget non trouvé",
      "failedToLoad": "Échec du chargement",
      "noDataAvailable": "Aucune donnée disponible",
      "noParametersConfigured": "Aucun paramètre configuré pour ce widget."
    },
    "tutorial": {
      "mainMessage": "Bienvenue sur votre tableau de bord ! Utilisez les boutons ci-dessus pour le personnaliser.",
      "callToAction": "Montrez-moi comment !",
      "instructions": {
        "add": {
          "title": "Bouton Ajouter un Widget",
          "description": "Ici, vous pourrez trouver des widgets par catégorie. Certains d'entre eux peuvent avoir des paramètres pour vous permettre un tableau de bord entièrement personnalisable. N'oubliez pas d'appuyer sur ENREGISTRER après avoir ajouté tous vos widgets."
        },
        "edit": {
          "title": "Modifier la Mise en Page du Widget",
          "description": "Ici, vous pourrez modifier votre tableau de bord : Ajouter ou supprimer des widgets, les déplacer et les redimensionner. N'oubliez pas d'enregistrer après modification."
        },
        "import": {
          "title": "Importer la Mise en Page",
          "description": "Avec un fichier de sauvegarde, vous pouvez l'importer ici. Note : Votre tableau de bord sera écrasé."
        },
        "export": {
          "title": "Exporter la Mise en Page",
          "description": "Une fois votre tableau de bord terminé, vous pouvez l'exporter pour avoir une sauvegarde OU l'envoyer à un autre utilisateur pour copier votre tableau de bord."
        }
      }
    }
  },
  "communication": {
    "title": "Communications",
    "menuTitle": "Communications",
    "menuName": "Communications",
    "inbox": "Boîte de réception",
    "markAsRead": "Marquer comme Lu",
    "subject": "Sujet",
    "date": "Date",
    "priority": "Priorité",
    "backToInbox": "Retour à la boîte de réception",
    "noMessages": "Aucun message dans votre boîte de réception.",
    "status": "Statut",
    "read": "Lu",
    "unread": "Non Lu",
    "edit": "Voir",
    "messages": {
      "markedAsRead": "Communication reconnue"
    }
  },
  "settings": {
    "title": "Paramètres",
    "theme": {
      "name": "Thème",
      "dark": "Sombre",
      "light": "Clair"
    }
  },
  "userInfo": {
    "title": "Informations Utilisateur",
    "permissions": "Autorisations",
    "userName": "Nom d'utilisateur",
    "fullName": "Nom Complet",
    "email": "E-mail",
    "employeeId": "ID Employé",
    "action": "Action",
    "permissionCode": "Code d'Autorisation"
  },
  "profile": {
    "title": "Mon Profil",
    "menuName": "Profil",
    "score": "Score de profil",
    "managerWarning": "Les informations fournies dans la page « Mon profil » sont accessibles aux responsables et aux RH de l'organisation à des fins de mappage des talents.",
    "photo": "Changer l'image",
    "name": "Nom",
    "email": "E-mail",
    "manager": "Responsable",
    "position": "Poste",
    "plant": "Usine",
    "businessArea": "Zone d'activité",
    "degreeType": "Diplôme",
    "degreeName": "Nom du Diplôme ou Certificat",
    "language": "Langue",
    "languagesInfo": "Sélectionnez toutes les langues que vous parlez",
    "geoMobility": {
      "label": "Mobilité géographique",
      "none": "Aucun",
      "local": "Local",
      "national": "National",
      "international": "International",
      "nationalAndInternational": "National et International"
    },
    "businessMobility": "Mobilité Unité commerciale",
    "skills": "Mes compétences",
    "skillsInfo": "Sélectionnez vos domaines d'expertise",
    "careerInterests": "Intérêts professionnels",
    "careerAspirations": "Aspirations professionnelles",
    "jobHistory": "Historique professionnel pertinent",
    "save": "Sauvegarder",
    "invalidPhotoFormat": "Image avec une extension invalide",
    "photoCrop": {
      "title": "Photo de profil",
      "selectImage": "Télécharger",
      "confirm": "Appliquer",
      "cancel": "Annuler",
      "deletePhoto": "Supprimer",
      "hint": "Faites glisser pour repositionner. Pincez ou faites défiler pour zoomer.",
      "emptyState": "Aucune image sélectionnée. Cliquez sur « Télécharger » pour commencer."
    },
    "messages": {
      "saved": "Profil enregistré avec succès",
      "notRegistered": "Vous n'êtes pas enregistré dans JTP. Veuillez contacter les RH pour être ajouté. En attendant, votre accès sera restreint."
    }
  },
  "impersonate": {
    "title": "Usurper l'Identité Utilisateur",
    "userName": "Connexion",
    "start": "Démarrer l'Usurpation d'Identité",
    "messages": {
      "impersonationStarted": "Session d'usurpation d'identité démarrée. Pour retourner à votre compte, veuillez vous déconnecter et vous reconnecter.",
      "userNotFound": "Utilisateur non trouvé. Veuillez vérifier le nom d'utilisateur et réessayer."
    }
  },
  "about": {
    "menuName": "À propos",
    "title": "À propos"
  },
  "releaseNotes": {
    "menuName": "Notes de Version",
    "title": "Notes de Version",
    "name": "Nom",
    "version": "Version",
    "description": "Description",
    "appType": "Type d'Application",
    "releaseDate": "Date de Publication",
    "messages": {
      "notFound": "Note de version non trouvée.",
      "saveError": "Erreur lors de l'enregistrement de la note de version. Veuillez réessayer plus tard."
    }
  },
  "help": {
    "menuTitle": "Aide",
    "externalLinkMessage": "Vous êtes sur le point d'ouvrir un lien externe :",
    "externalLinkConfirm": "Ouvrir le lien",
    "lastUpdated": "Dernière mise à jour : {date}",
    "wasThisHelpful": "Était-ce utile ?",
    "helpful": "Utile",
    "notHelpful": "Pas utile",
    "pageModal": {
      "title": "Aide pour cette page",
      "intro": "Les articles d'aide fournissent des conseils pour la page sur laquelle vous vous trouvez. Sélectionnez-en un pour l'ouvrir ou fermez cette fenêtre."
    }
  },
  "admin": {
    "menuTitle": "Administration",
    "appCustomizations": {
      "menuName": "Personnalisations de l'App",
      "pageTitle": "Personnalisations de l'App",
      "imageLogos": "Logos Image",
      "headerLogo": "Logo En-tête",
      "menuLogo": "Logo Menu",
      "bannerImage": "Image Bannière",
      "upload": "Téléverser",
      "remove": "Supprimer",
      "noCustom": "Image par défaut",
      "preview": "Aperçu",
      "messages": {
        "saved": "Personnalisations enregistrées avec succès.",
        "invalidKey": "Clé de logo invalide.",
        "invalidLanguage": "Code de langue invalide.",
        "fileRequired": "Le fichier est requis.",
        "fileTooLarge": "Le fichier dépasse la taille maximale autorisée de 2 Mo.",
        "fileTypeNotAllowed": "Type de fichier non autorisé. Utilisez PNG, JPEG ou WebP.",
        "notFound": "Personnalisation non trouvée."
      }
    },
    "help": {
      "menuName": "Aide",
      "pageTitle": "Aide",
      "title": "Titre",
      "description": "Description",
      "isActive": "Actif",
      "displayOrder": "Ordre d'affichage",
      "securityResources": "Ressources de sécurité",
      "securityResourcesInfo": "Liste de permissions séparées par des virgules. Laissez vide pour le rendre visible par tous ; sinon, l'utilisateur doit avoir au moins une des permissions indiquées.",
      "isMenuDisplayed": "Afficher dans le menu",
      "isMenuDisplayedInfo": "Lorsque désactivé, cette aide est masquée du menu d'aide, mais peut toujours être ouverte depuis l'icône d'aide des pages associées.",
      "isTrackingEnabled": "Activer le suivi",
      "isTrackingEnabledInfo": "Lorsqu'il est activé, les vues sont enregistrées par employé et une évaluation « était-ce utile » est affichée sur la page d'aide.",
      "viewCount": "Vues",
      "viewCountValue": "Vu {views} fois par {viewers} personnes",
      "viewCountInfo": "Nombre total de vues et nombre d'employés distincts ayant ouvert cette aide.",
      "helpfulCount": "Utile",
      "notHelpfulCount": "Pas utile",
      "associatedMenus": "Pages associées",
      "associatedMenusInfo": "Associez cette aide à une ou plusieurs pages afin qu'elle puisse être ouverte directement depuis l'icône d'aide de ces pages.",
      "addMenu": "Ajouter une page",
      "add": "Ajouter une aide",
      "edit": "Modifier l'aide",
      "delete": {
        "title": "Supprimer l'aide",
        "text": "Êtes-vous sûr de vouloir supprimer cette entrée d'aide ?"
      },
      "messages": {
        "created": "Aide créée avec succès.",
        "updated": "Aide mise à jour avec succès.",
        "deleted": "Aide supprimée avec succès.",
        "notFound": "Aide introuvable."
      }
    },
    "menuHierarchy": {
      "menuName": "Hiérarchie du Menu",
      "pageTitle": "Hiérarchie du Menu",
      "displayName": "Nom d'Affichage",
      "route": "Route",
      "routeParam": "Paramètre du Menu",
      "securityResources": "Ressources de Sécurité",
      "children": "Sous-Menus",
      "isActive": "Est Actif",
      "icon": "Icône",
      "iconHelpText": "Bibliothèque d'icônes",
      "displayOrder": "Ordre d'Affichage",
      "edit": "Modifier l'Élément du Menu",
      "messages": {
        "success": "Élément du menu enregistré avec succès."
      }
    },
    "notificationTemplate": {
      "menuName": "Modèle de Notification",
      "pageTitle": "Modèle de Notification",
      "name": "Nom",
      "parent": "Modèle Parent",
      "parentInfo": "Seuls les modèles commençant par masterTemplate peuvent être utilisés comme modèle parent.",
      "pushNotificationEnabled": "Notification Push Activée",
      "pushRoute": "Route de Notification Push",
      "sqlQuery": "Requête SQL",
      "sqlQueryDateFormatInfo": "Les colonnes de date doivent être formatées au format MM/dd/yyyy.",
      "generalSection": "Informations Générales",
      "emailSection": "Notification par E-mail",
      "emailSubject": "Sujet de l'E-mail",
      "emailBody": "Corps de l'E-mail (HTML)",
      "pushSection": "Notification Push",
      "pushSubject": "Sujet Push",
      "pushBody": "Corps Push",
      "overrideNotificationTemplate": "Remplacer le Modèle de Notification",
      "add": "Ajouter un Modèle",
      "edit": "Modifier le Modèle",
      "delete": {
        "title": "Supprimer le Modèle",
        "text": "Êtes-vous sûr de vouloir supprimer le modèle \"{name}\" ?"
      },
      "attachment": {
        "title": "Joindre un fichier",
        "attachment": "Fichier Joint",
        "attach": "Joindre",
        "noAttachedFile": "Aucun fichier joint...",
        "messages": {
          "uploadedSuccessfully": "Fichier joint avec succès."
        },
        "delete": {
          "title": "Supprimer le fichier joint",
          "text": "Êtes-vous sûr de vouloir supprimer le fichier joint \"{name}\" ?"
        }
      },
      "messages": {
        "created": "Modèle de notification créé avec succès.",
        "updated": "Modèle de notification mis à jour avec succès.",
        "deleted": "Modèle de notification supprimé avec succès.",
        "alreadyExists": "Un modèle de notification avec ce nom existe déjà.",
        "fileRequired": "Le fichier est obligatoire.",
        "importError": "Une erreur s'est produite lors de l'importation du modèle de notification.",
        "notFound": "Modele de notification introuvable."
      }
    },
    "department": {
      "menuName": "Département",
      "pageTitle": "Département",
      "name": "Nom",
      "isActive": "Est Actif",
      "add": "Ajouter un Département",
      "edit": "Modifier le Département",
      "delete": {
        "title": "Supprimer le Département",
        "text": "Êtes-vous sûr de vouloir supprimer ce département ?"
      },
      "messages": {
        "created": "Département créé avec succès.",
        "updated": "Département mis à jour avec succès.",
        "deleted": "Département supprimé avec succès."
      }
    },
    "businessArea": {
      "menuName": "Domaine d'Affaires",
      "pageTitle": "Domaine d'Affaires",
      "id": "Id",
      "externalId": "Id Externe",
      "description": "Description",
      "calendarId": "Calendrier",
      "isActive": "Est Actif",
      "edit": "Modifier le Domaine d'Affaires",
      "messages": {
        "created": "Domaine d'Affaires créé avec succès.",
        "updated": "Domaine d'Affaires mis à jour avec succès.",
        "deleted": "Domaine d'Affaires supprimé avec succès."
      }
    },
    "businessUnit": {
      "menuName": "Unité Commerciale",
      "pageTitle": "Unité Commerciale",
      "id": "Id",
      "externalId": "Id Externe",
      "description": "Description",
      "isActive": "Est Active",
      "edit": "Modifier l’Unité Commerciale",
      "messages": {
        "created": "Unité Commerciale créée avec succès.",
        "updated": "Unité Commerciale mise à jour avec succès.",
        "deleted": "Unité Commerciale supprimée avec succès.",
        "inUse": "L’Unité Commerciale est utilisée. Supprimez d’abord ses dépendances.",
        "notFound": "Enregistrement de l’Unité Commerciale introuvable"
      },
      "add": "Ajouter une Unité Commerciale",
      "delete": {
        "title": "Supprimer l’Unité Commerciale",
        "text": "Êtes-vous sûr de vouloir supprimer cette Unité Commerciale ?"
      }
    },
    "division": {
      "menuName": "Division",
      "pageTitle": "Division",
      "id": "Id",
      "externalId": "Id Externe",
      "description": "Description",
      "isActive": "Est Active",
      "businessUnitId": "Unité Commerciale",
      "edit": "Modifier la Division",
      "messages": {
        "created": "Division créée avec succès.",
        "updated": "Division mise à jour avec succès.",
        "deleted": "Division supprimée avec succès."
      },
      "add": "Ajouter une Division",
      "delete": {
        "title": "Supprimer la Division",
        "text": "Êtes-vous sûr de vouloir supprimer cette Division ?"
      }
    },
    "organization": {
      "menuName": "Organisation",
      "pageTitle": "Organisation",
      "id": "ID",
      "externalId": "ID Externe",
      "name": "Nom",
      "plantAreaId": "Zone d'Usine",
      "organizationParentId": "Organisation Parente",
      "edit": "Modifier l'Organisation",
      "messages": {
        "created": "Organisation créée avec succès.",
        "updated": "Organisation mise à jour avec succès.",
        "deleted": "Organisation supprimée avec succès."
      },
      "add": "Ajouter une Organisation",
      "delete": {
        "title": "Supprimer l'Organisation",
        "text": "Êtes-vous sûr de vouloir supprimer cette organisation ?"
      }
    },
    "plant": {
      "menuName": "Usine",
      "pageTitle": "Usine",
      "id": "Id",
      "name": "Nom",
      "alias": "Alias",
      "isActive": "Actif",
      "divisionId": "Division",
      "countryId": "Pays",
      "employeeCanUpdateGoals": "L'employé peut mettre à jour les objectifs",
      "employeeCanUpdateTracks": "L'employé peut mettre à jour les résultats",
      "employeeCanIncludeKPI": "L'employé peut créer un KPI",
      "managerCanUpdateGoals": "Le manager peut mettre à jour les objectifs",
      "managerCanUpdateTracks": "Le manager peut mettre à jour les résultats",
      "managerCanIncludeKPI": "Le manager peut créer un KPI",
      "edit": "Modifier l'Usine",
      "messages": {
        "created": "Usine créée avec succès.",
        "updated": "Usine mise à jour avec succès.",
        "deleted": "Usine supprimée avec succès.",
        "inUse": "L'enregistrement de l'usine est utilisé. Supprimez d'abord les enregistrements liés.",
        "notFound": "Usine non trouvée"
      },
      "add": "Ajouter une Usine",
      "delete": {
        "title": "Supprimer l'Usine",
        "text": "Êtes-vous sûr de vouloir supprimer cette Usine ?"
      }
    },
    "personnelArea": {
      "menuName": "Zone du Personnel",
      "pageTitle": "Zone du Personnel",
      "id": "Id",
      "description": "Description",
      "externalId": "Id Externe",
      "plantId": "Site",
      "isActive": "Actif",
      "sourceModifiedDate": "Date de Modification Source",
      "edit": "Modifier la Zone du Personnel",
      "messages": {
        "created": "Zone du Personnel créée avec succès.",
        "updated": "Zone du Personnel mise à jour avec succès.",
        "deleted": "Zone du Personnel supprimée avec succès.",
        "inUse": "L'enregistrement de la Zone du Personnel est en cours d'utilisation. Supprimez d'abord ses utilisations.",
        "notFound": "Enregistrement de la Zone du Personnel introuvable",
        "alreadyExists": "Une zone du personnel avec cette description existe déjà.",
        "fileRequired": "Le fichier est obligatoire.",
        "importError": "Une erreur s'est produite lors de l'importation de la zone du personnel.",
        "invalidPlant": "Id de Site invalide",
        "duplicateExternalId": "Id Externe dupliqué",
        "importSuccess": "Zone du Personnel importée avec succès. Vous recevrez le fichier par e-mail",
        "exportSuccess": "Zone du Personnel exportée avec succès. Vous recevrez le fichier par e-mail",
        "exportFailed": "Échec de l'exportation de la zone du personnel.",
        "importFailed": "Échec de l'importation de la zone du personnel.",
        "personNotFound": "Personne introuvable pour effectuer l'importation. Contactez l'Administrateur.",
        "emailNotFound": "E-mail introuvable pour effectuer l'importation. Contactez l'Administrateur.",
        "importFalied": "L'importation de la zone du personnel a échoué."
      },
      "add": "Ajouter une Zone du Personnel",
      "delete": {
        "title": "Supprimer la Zone du Personnel",
        "text": "Êtes-vous sûr de vouloir supprimer cette Zone du Personnel ?"
      }
    },
    "position": {
      "menuName": "Poste",
      "pageTitle": "Poste",
      "id": "Id",
      "description": "Description",
      "externalId": "Id Externe",
      "active": "Actif",
      "jobCode": "Emploi",
      "jobId": "Emploi",
      "organizationId": "Organisation",
      "employeeSubGroupId": "Sous-groupe d'Employés",
      "costCenterId": "Centre de Coûts",
      "salaryLevelId": "Niveau de Salaire",
      "businessAreaId": "Domaine d'Activité",
      "bonusFrequencyId": "Fréquence de Prime",
      "personnelAreaCode": "Zone du Personnel",
      "payGradeType": "Type d'Échelon Salarial",
      "payGradeArea": "Zone d'Échelon Salarial",
      "employeeGroupId": "Groupe d'Employés",
      "salaryGroupId": "Groupe Salarial",
      "minimum": "Minimum",
      "midpoint": "Point Milieu",
      "edit": "Modifier la Zone de Poste",
      "messages": {
        "created": "Poste créé avec succès.",
        "updated": "Poste mis à jour avec succès.",
        "inUse": "L'enregistrement du poste est en cours d'utilisation. Supprimez d'abord ses utilisations.",
        "notFound": "Enregistrement du poste introuvable"
      },
      "add": "Ajouter un Poste"
    },
    "positionProfile": {
      "pageTitle": "Poste Critique",
      "globalCritical": "Critique Global",
      "countryCritical": "Critique par Pays",
      "businessUnitCritical": "Critique par Unité Commerciale",
      "positionType": "Type de Poste",
      "sucessorType": "Type de Successeur",
      "potentialSuccessorType": "Type de Successeur",
      "potentialSuccessorId": "Successeur Potentiel",
      "readinessFactor": "Facteur de Préparation",
      "potentialSuccessorName": "Nom",
      "potentialSuccessorCompany": "Entreprise",
      "potentialSuccessorLinkedIn": "URL LinkedIn",
      "potentialSuccessorNotes": "Notes",
      "messages": {
        "created": "La position critique a été créée avec succès.",
        "updated": "La position critique a été mise à jour avec succès."
      }
    },
    "configuration": {
      "menuName": "Configuration",
      "pageTitle": "Configuration",
      "key": "Clé",
      "value": "Valeur",
      "editorType": "Type",
      "add": "Ajouter une Configuration",
      "edit": "Modifier la Configuration",
      "delete": {
        "title": "Supprimer la Configuration",
        "text": "Êtes-vous sûr de vouloir supprimer cette configuration ?"
      },
      "messages": {
        "created": "Configuration créée avec succès.",
        "updated": "Configuration mise à jour avec succès.",
        "deleted": "Configuration supprimée avec succès."
      },
      "types": {
        "text": "Texte",
        "string": "Chaîne",
        "number": "Nombre",
        "int": "Entier",
        "boolean": "Booléen"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nom",
      "description": "Description",
      "securityResources": "Ressources de Sécurité",
      "link": "Lien",
      "query": "Requête SQL",
      "queryRequired": "La requête SQL est obligatoire.",
      "sqlQueryDateFormatInfo": "Les colonnes de date doivent être formatées au format MM/dd/yyyy.",
      "minHeight": "Hauteur Minimale",
      "minWidth": "Largeur Minimale",
      "autoApplied": "Appliquer à tous les tableaux de bord",
      "autoAppliedHelp": "Cela forcera ce widget sur tous les tableaux de bord, et les utilisateurs continueront à le voir même s'ils tentent de le supprimer.",
      "type": "Type",
      "category": "Catégorie",
      "add": "Ajouter un Widget",
      "edit": "Modifier le Widget",
      "delete": {
        "title": "Supprimer le Widget",
        "text": "Êtes-vous sûr de vouloir supprimer ce widget ?"
      },
      "examples": {
        "viewSQLExamples": "Voir les exemples SQL",
        "general": "Général",
        "generalDescription": "Par défaut, le système fournit les paramètres suivants, qui peuvent être référencés directement dans toute requête SQL de widget.",
        "loggedUserNameDescription": "Nom d'utilisateur de connexion de l'utilisateur actuellement connecté (par exemple : {email}).",
        "loggedUserEmployeeIdDescription": "Identifiant d'employé de l'utilisateur actuellement connecté.",
        "loggedUserLanguageDescription": "Code de langue de l'utilisateur actuellement connecté (par exemple : en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "Identifiant unique de l'utilisateur (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Identifiant unique chiffré de l'utilisateur",
        "listDescription": "Chaque ligne représente un élément de liste.",
        "numberDescription": "Renvoie une seule valeur numérique.",
        "donutDescription": "Les étiquettes et les valeurs doivent être alignées par position.",
        "lineDescription": "Chaque ligne représente une série de lignes."
      },
      "messages": {
        "created": "Widget créé avec succès.",
        "updated": "Widget mis à jour avec succès.",
        "deleted": "Widget supprimé avec succès.",
        "fileRequired": "Le fichier est obligatoire.",
        "importError": "Une erreur s'est produite lors de l'importation du widget.",
        "queryVariablesMissing": "Les variables suivantes sont manquantes dans la requête du widget : \"{variables}\". Veuillez les ajouter à la requête pour assurer un fonctionnement correct."
      }
    },
    "reportColumnTemplate": {
      "menuName": "Modèles de Colonnes de Rapport",
      "pageTitle": "Modèles de Colonnes de Rapport",
      "id": "ID",
      "description": "Description",
      "template": "Modèle",
      "templateHelp": "Utilisez {value} comme espace réservé pour la valeur de cellule. HTML est pris en charge.",
      "add": "Ajouter un Modèle",
      "edit": "Modifier le Modèle",
      "delete": {
        "title": "Supprimer le Modèle",
        "text": "Êtes-vous sûr de vouloir supprimer \"{name}\" ?"
      },
      "messages": {
        "created": "Modèle créé avec succès.",
        "updated": "Modèle mis à jour avec succès.",
        "deleted": "Modèle supprimé avec succès."
      }
    },
    "widgetCategory": {
      "menuName": "Catégorie de Widget",
      "pageTitle": "Catégorie de Widget",
      "name": "Nom",
      "description": "Description",
      "type": "Type",
      "add": "Ajouter une Catégorie de Widget",
      "edit": "Modifier la Catégorie de Widget",
      "delete": {
        "title": "Supprimer la Catégorie de Widget",
        "text": "Êtes-vous sûr de vouloir supprimer cette catégorie de widget ?"
      },
      "messages": {
        "created": "Catégorie de Widget créée avec succès.",
        "updated": "Catégorie de Widget mise à jour avec succès.",
        "deleted": "Catégorie de Widget supprimée avec succès."
      }
    },
    "widgetType": {
      "menuName": "Type de Widget",
      "pageTitle": "Type de Widget",
      "name": "Nom",
      "types": {
        "number": "Nombre",
        "list": "Liste",
        "donut": "Graphique en anneau",
        "line": "Ligne"
      }
    },
    "widgetParameter": {
      "menuName": "Paramètre de Widget",
      "menuTitle": "Paramètre de Widget",
      "title": "Paramètre de Widget",
      "name": "Nom",
      "nameInfo": "Nom utilisé pour identifier le paramètre dans la requête SQL du widget. N'utilisez pas d'espaces ou de caractères spéciaux.",
      "nameUniqueError": "Un Paramètre de Widget avec ce nom existe déjà.",
      "description": "Description",
      "isRequired": "Est Obligatoire ?",
      "isMultiple": "Est Multiple ?",
      "status": "Statut",
      "edit": "Modifier le Paramètre de Widget",
      "add": "Ajouter un Paramètre de Widget",
      "type": "Type",
      "data": "Requête SQL",
      "dataInfo": "La requête SQL doit retourner deux colonnes nommées 'Value' et 'Text'.",
      "listOfValues": "Liste de Valeurs",
      "addValue": "Ajouter une Valeur",
      "value": "Valeur",
      "label": "Étiquette",
      "delete": {
        "title": "Supprimer le Paramètre de Widget",
        "text": "Êtes-vous sûr de vouloir supprimer {name} ?"
      },
      "types": {
        "text": "Texte",
        "number": "Nombre",
        "date": "Date",
        "boolean": "Booléen",
        "select": "Liste",
        "sql": "Liste de Requête"
      },
      "messages": {
        "notFound": "Paramètre de Widget non trouvé.",
        "saveSuccess": "Paramètre de Widget enregistré avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement du Paramètre de Widget.",
        "deleteSuccess": "Paramètre de Widget supprimé avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression du Paramètre de Widget.",
        "isInUse": "Impossible de supprimer le Paramètre de Widget car il est en cours d'utilisation."
      }
    },
    "people": {
      "menuName": "Personnes",
      "pageTitle": "Personnes",
      "edit": "Modifier la Personne",
      "employeeId": "ID Employé",
      "person": "Personne",
      "id": "Id",
      "name": "Nom",
      "email": "E-mail",
      "externalId": "ID Externe",
      "status": "Statut",
      "type": "Type",
      "positionShortDescription": "Brève description du poste",
      "hireDate": "Date d'Embauche",
      "culture": "Culture",
      "sourceJTPInstance": "Code JTP Source",
      "documentId": "ID Document",
      "manager": "Responsable",
      "position": "Poste",
      "bonusFrequency": "Fréquence de Prime",
      "businessArea": "Domaine d'Activité",
      "personnelArea": "Zone du Personnel",
      "division": "Division",
      "plant": "Site de production",
      "businessUnit": "Unité d'affaires",
      "shiftId": "Équipe",
      "plantAreaId": "Zone d'Usine",
      "immigrationTypeId": "Type d'Immigration",
      "customerSpecificStatus": "Statut Spécifique Client",
      "vendorNumber": "Numéro Fournisseur",
      "accountNumber": "4 Derniers Chiffres du Compte",
      "overrideManagerId": "Responsable de Remplacement",
      "saipAllocation": "Allocation SAIP",
      "requirePrivacyConsent": "Employé Global",
      "globalDirectReports": "Subordonnés Directs Globaux",
      "globalManagerOverrideHelpText": "Les employés sélectionnés ne relèveront de cet employé qu'à l'échelle mondiale. Si cet employé a des subordonnés directs, tous seront également marqués comme globaux.",
      "messages": {
        "updated": "Personne mise à jour avec succès.",
        "notFound": "Enregistrement de la personne introuvable.",
        "alreadyExists": "Une personne avec cette description existe déjà.",
        "fileRequired": "Le fichier est obligatoire.",
        "importError": "Une erreur s'est produite lors de l'importation des personnes.",
        "importSuccess": "Personnes importées avec succès. Vous recevrez le fichier par e-mail.",
        "importFailed": "Échec de l'importation des personnes.",
        "personNotFound": "Personne introuvable pour effectuer l'importation. Contactez l'administrateur.",
        "emailNotFound": "E-mail introuvable pour effectuer l'importation. Contactez l'administrateur.",
        "importFalied": "L'importation des personnes a échoué."
      },
      "personTypes": {
        "unknown": "Inconnu",
        "salariedEmployee": "Employé Salarié",
        "contractor": "Contractuel",
        "vendor": "Fournisseur",
        "hourlyEmployee": "Employé Horaire",
        "external": "Externe",
        "duHourlyInactive": "DU Horaire Inactif",
        "duSalariedInactive": "DU Salarié Inactif",
        "duTruckDriverIn": "DU Chauffeur de Camion En",
        "executive": "Cadre",
        "union": "Syndiqué",
        "nonUnion": "Non Syndiqué",
        "unionPossible": "Syndicalisation Possible",
        "salariedNonExempt": "Salarié Non Exempté",
        "hourly": "Horaire",
        "duPaidLeave": "DU Congé Payé",
        "truckDriver": "Chauffeur de Camion",
        "duUnpaidLeave": "DU Congé Non Payé",
        "workRelease": "Libération de Travail",
        "externalAccessLevelOne": "Accès Externe Niveau Un",
        "externalAccessLevelTwo": "Accès Externe Niveau Deux",
        "externalAccessLevelThree": "Accès Externe Niveau Trois",
        "externalAccessLevelFour": "Accès Externe Niveau Quatre",
        "externalAccessLevelFive": "Accès Externe Niveau Cinq",
        "globalEmployee": "Employé Global"
      },
      "customerSpecificStatuses": {
        "unknown": "Inconnu",
        "active": "Actif",
        "inactive": "Inactif",
        "incomeAssistance": "Aide au revenu",
        "lOA": "Congé",
        "retiree": "Retraité",
        "withdrawn": "Retiré"
      }
    },
    "companyCode": {
      "menuName": "Codes de Société"
    },
    "costCenter": {
      "menuName": "Centres de Coûts"
    },
    "currency": {
      "menuName": "Devises"
    },
    "exchangeRate": {
      "menuName": "Taux de Change"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Échelles d'évaluation",
      "pageTitle": "Échelles d'évaluation",
      "description": "Description",
      "add": "Ajouter une échelle d'évaluation",
      "edit": "Modifier l'échelle d'évaluation",
      "delete": {
        "title": "Supprimer l'échelle d'évaluation",
        "text": "Êtes-vous sûr de vouloir supprimer cette échelle d'évaluation ?"
      },
      "messages": {
        "notFound": "Échelle d'évaluation non trouvée.",
        "saveSuccess": "Échelle d'évaluation enregistrée avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement de l'échelle d'évaluation.",
        "deleteSuccess": "Échelle d'évaluation supprimée avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression de l'échelle d'évaluation.",
        "isInUse": "Impossible de supprimer l'échelle d'évaluation car elle est en cours d'utilisation.",
        "duplicateName": "Une échelle d'évaluation avec cette description existe déjà."
      },
      "options": {
        "title": "Options",
        "value": "Valeur",
        "description": "Description",
        "explanation": "Explication",
        "itemOrder": "Ordre",
        "color": "Couleur",
        "commentConfig": "Configuration des commentaires",
        "add": "Ajouter une option",
        "edit": "Modifier l'option",
        "delete": {
          "title": "Supprimer l'option",
          "text": "Êtes-vous sûr de vouloir supprimer cette option ?"
        },
        "messages": {
          "created": "Option créée avec succès.",
          "updated": "Option mise à jour avec succès.",
          "deleted": "Option supprimée avec succès.",
          "notFound": "Option non trouvée.",
          "duplicateValue": "Deux options ou plus ont la même valeur. Chaque option doit avoir une valeur unique.",
          "duplicateDescription": "Deux options ou plus ont la même description. Chaque option doit avoir une description unique."
        },
        "commentConfigType": {
          "followForm": "Suivre le formulaire",
          "required": "Obligatoire",
          "notRequired": "Non obligatoire"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Groupes de questions",
      "pageTitle": "Groupes de questions",
      "name": "Nom",
      "description": "Description",
      "add": "Ajouter un groupe de questions",
      "edit": "Modifier le groupe de questions",
      "delete": {
        "title": "Supprimer le groupe de questions",
        "text": "Êtes-vous sûr de vouloir supprimer ce groupe de questions : {name} ?"
      },
      "messages": {
        "notFound": "Groupe de questions non trouvé.",
        "saveSuccess": "Groupe de questions enregistré avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement du groupe de questions.",
        "deleteSuccess": "Groupe de questions supprimé avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression du groupe de questions.",
        "isInUse": "Impossible de supprimer le groupe de questions car il est en cours d'utilisation."
      }
    },
    "question": {
      "menuTitle": "Questions",
      "pageTitle": "Questions",
      "name": "Nom",
      "weight": "Poids",
      "commentDisabled": "Commentaires désactivés",
      "description": "Description",
      "questionGroup": "Groupe de questions",
      "questionOption": "Échelle d'évaluation",
      "add": "Ajouter une question",
      "edit": "Modifier la question",
      "delete": {
        "title": "Supprimer la question",
        "text": "Êtes-vous sûr de vouloir supprimer cette question ?"
      },
      "messages": {
        "notFound": "Question non trouvée.",
        "saveSuccess": "Question enregistrée avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement de la question.",
        "deleteSuccess": "Question supprimée avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression de la question.",
        "isInUse": "Impossible de supprimer la question car elle est en cours d'utilisation."
      }
    },
    "formCategory": {
      "menuTitle": "Catégories de formulaires",
      "pageTitle": "Catégories de formulaires",
      "name": "Nom",
      "description": "Description",
      "add": "Ajouter une catégorie de formulaires",
      "edit": "Modifier la catégorie de formulaires",
      "delete": {
        "title": "Supprimer la catégorie de formulaires",
        "text": "Êtes-vous sûr de vouloir supprimer cette catégorie de formulaires ?"
      },
      "messages": {
        "notFound": "Catégorie de formulaires non trouvée.",
        "saveSuccess": "Catégorie de formulaires enregistrée avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement de la catégorie de formulaires.",
        "deleteSuccess": "Catégorie de formulaires supprimée avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression de la catégorie de formulaires.",
        "isInUse": "Impossible de supprimer la catégorie de formulaires car elle est en cours d'utilisation."
      }
    },
    "formDelegate": {
      "menuTitle": "Délégué de Formulaire",
      "pageTitle": "Délégué de Formulaire",
      "form": "Formulaire",
      "manager": "Gestionnaire",
      "delegate": "Délégué",
      "add": "Ajouter un Délégué de Formulaire",
      "edit": "Modifier le Délégué de Formulaire",
      "delegatedToPerson": "Déléguer à",
      "invitedEnabled": "Invitation Activée",
      "signEnabled": "Signature Activée",
      "resultViewerEnabled": "Visualiseur de Résultats Activé",
      "delete": {
        "title": "Supprimer le Délégué de Formulaire",
        "text": "Êtes-vous sûr de vouloir supprimer ce délégué de formulaire ?"
      },
      "messages": {
        "notFound": "Délégué de Formulaire non trouvé.",
        "saveSuccess": "Délégué de Formulaire enregistré avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement du Délégué de Formulaire.",
        "deleteSuccess": "Délégué de Formulaire supprimé avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression du Délégué de Formulaire.",
        "managerDisabledMessage": "Vous n'avez pas accès à ce formulaire"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Délégué de Formulaire Global",
      "pageTitle": "Délégué de Formulaire Global"
    },
    "form": {
      "menuTitle": "Formulaires",
      "pageTitle": "Formulaires",
      "id": "Id",
      "description": "Description",
      "category": "Catégorie",
      "categoryId": "Catégorie",
      "stage": {
        "label": "Étape",
        "preparation": "Préparation",
        "execution": "Exécution",
        "managerReview": "Révision du responsable",
        "participantReview": "Révision du participant",
        "closed": "Fermé"
      },
      "active": "Actif",
      "maximumHireDate": "Date limite d'embauche",
      "maxPeopleEvaluateAlert": "Alerte d'évaluation max. d'employés",
      "includeGlobalReporting": "Rapport global",
      "customerSpecificStatus": "Statut spécifique du client",
      "employeeType": "Type d'employé",
      "reportType": {
        "label": "Type de rapport",
        "question": "Par Question",
        "questionGroup": "Par Groupe de questions"
      },
      "directReportBox": "Évaluation du subordonné",
      "selfEvaluationBox": "Auto-évaluation",
      "managerEvaluationBox": "Évaluation du responsable",
      "crossGroupEvaluationBox": "Évaluation intergroupe",
      "freeEvaluationBox": "Évaluation libre",
      "dueDatesBox": "Date d'échéance",
      "evaluation": "Évaluation",
      "comments": "Commentaires",
      "weight": "Poids",
      "minCrossGroupEvaluations": "Évaluations intergroupe min.",
      "crossGroupDueDate": "Créer Cross Group – Soi-même",
      "evaluationDueDate": "Créer Cross Group – Responsable",
      "managerSignDueDate": "Final Cross Group – Responsable",
      "participantSignDueDate": "Date de Clôture",
      "processDueDate": "Évaluation",
      "beginningReviewDate": "Début de la période d'évaluation",
      "endingReviewDate": "Fin de la période d'évaluation",
      "maxReleaseQuestionnaireDate": "Publication du questionnaire",
      "createdBy": "Créé par",
      "createdDate": "Date de création",
      "modifiedBy": "Modifié par",
      "modifiedDate": "Date de modification",
      "maximumHireDateHelpText": "Date d'embauche maximale de l'employé pour participer, sauf si l'employé est un responsable.",
      "maxPeopleEvaluateAlertHelpText": "Afficher une alerte une fois que l'employé atteint le nombre maximum de personnes à évaluer",
      "includeGlobalReportingHelpText": "Inclure dans le rapport global",
      "directReportEvaluationHelpText": "Évaluation du subordonné",
      "directReportCommentsHelpText": "Commentaires du subordonné",
      "directReportWeightHelpText": "Poids du subordonné",
      "selfEvaluationHelpText": "Auto-évaluation",
      "selfCommentsHelpText": "Commentaires d'Auto-évaluation",
      "selfWeightHelpText": "Poids d'Auto-évaluation",
      "managerEvaluationHelpText": "Évaluation du Responsable",
      "managerCommentsHelpText": "Commentaires du Responsable",
      "managerWeightHelpText": "Poids du Responsable",
      "freeCommentsHelpText": "Commentaires Libres",
      "freeWeightHelpText": "Poids Libre",
      "crossGroupEvaluationHelpText": "Évaluation Intergroupe",
      "crossGroupCommentsHelpText": "Commentaires Intergroupe",
      "crossGroupWeightHelpText": "Poids Intergroupe",
      "minCrossGroupEvaluationsHelpText": "Nombre minimum d'évaluations intergroupe pour permettre au responsable de publier le questionnaire.",
      "maxReleaseQuestionnaireDateHelpText": "Date maximale pour que le responsable publie le questionnaire",
      "add": "Ajouter un Formulaire",
      "edit": "Modifier le Formulaire",
      "updateCounters": "Mettre à Jour les Compteurs",
      "detailedResult": "Résultat Détaillé",
      "move": {
        "button": "Déplacer vers {stage}",
        "title": "Déplacer l'Étape",
        "text": "Êtes-vous sûr de vouloir déplacer ce formulaire vers l'étape {stage} ?"
      },
      "duplicate": {
        "button": "Dupliquer",
        "title": "Dupliquer le Formulaire",
        "text": "Êtes-vous sûr de vouloir dupliquer ce formulaire ?"
      },
      "delete": {
        "title": "Supprimer le Formulaire",
        "text": "Êtes-vous sûr de vouloir supprimer ce formulaire : {name} ?"
      },
      "formQuestion": {
        "title": "Questions du Formulaire",
        "question": "Question",
        "itemOrder": "Ordre",
        "questionGroup": "Groupe de Questions",
        "add": "Ajouter une Question",
        "edit": "Modifier la Question",
        "delete": {
          "title": "Supprimer la Question",
          "text": "Êtes-vous sûr de vouloir supprimer {name} de ce formulaire ?"
        },
        "messages": {
          "saveSuccess": "Question du Formulaire enregistrée avec succès.",
          "saveError": "Une erreur s'est produite lors de l'enregistrement de la Question du Formulaire.",
          "deleteSuccess": "Question du Formulaire supprimée avec succès.",
          "deleteError": "Une erreur s'est produite lors de la suppression de la Question du Formulaire.",
          "duplicateQuestion": "Cette question est déjà ajoutée au formulaire.",
          "notFound": "Question du Formulaire non trouvée.",
          "questionNotFound": "Question non trouvée."
        }
      },
      "messages": {
        "notFound": "Formulaire non trouvé.",
        "saveSuccess": "Formulaire enregistré avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement du Formulaire.",
        "deleteSuccess": "Formulaire supprimé avec succès.",
        "deleteError": "Une erreur s'est produite lors de la suppression du Formulaire.",
        "deleteNotAllowed": "Impossible de supprimer un formulaire qui n'est pas à l'étape de Préparation.",
        "isInUse": "Impossible de supprimer le Formulaire car il est en cours d'utilisation.",
        "atLeastOneMemberEvaluate": "Au moins un type d'évaluateur (Subordonné, Auto, Responsable ou Intergroupe) doit être activé.",
        "maximumHireDateRequired": "La Date d'Embauche Maximale est requise.",
        "dueDatesRequired": "Toutes les dates d'échéance sont requises.",
        "moveStageSuccess": "Formulaire déplacé vers l'étape suivante avec succès.",
        "moveStageNotAllowed": "Impossible de déplacer un formulaire fermé vers une autre étape.",
        "moveStageNotAllowedNoPeople": "Le formulaire n'a pas de personnes. Pour déplacer, visitez la page Personnes du Formulaire pour inclure des personnes dans ce formulaire.",
        "moveStageNotAllowedNoQuestions": "Le formulaire n'a pas de questions. Pour déplacer, insérez au moins une question.",
        "duplicateSuccess": "Formulaire dupliqué avec succès.",
        "updateCountersSuccess": "La mise à jour des compteurs a été déclenchée.",
        "detailedResultSuccess": "La génération du résultat détaillé a été déclenchée."
      }
    },
    "formEmailSender": {
      "menuTitle": "Expéditeur de formulaire par e-mail",
      "pageTitle": "Expéditeur de formulaire par e-mail",
      "messages": {
        "emailsSent": "E-mails envoyés avec succès."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Manager",
        "directReport": "Subordonné direct",
        "crossGroup": "Intergroupe",
        "selfEvaluation": "Auto-évaluation",
        "freeEvaluation": "Évaluation libre"
      },
      "questionnaireRequestTypes": {
        "default": "Défaut",
        "manager": "Manager",
        "directReport": "Employé"
      },
      "questionnaireStatus": {
        "done": "Terminé",
        "declined": "Refusé",
        "open": "Ouvert"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Self, Directs & Manager",
        "crossGroupPeers": "Intergroupe (Pairs)",
        "crossGroup": "Intergroupe",
        "freeEvaluation": "Évaluation libre"
      },
      "questionnairesReport": {
        "title": "Rapport des questionnaires",
        "messages": {
          "confirm": "Le fichier sera exporté. Vous recevrez les résultats par e-mail bientôt.",
          "success": "L'exportation du rapport des questionnaires a été déclenchée. Vous recevrez les résultats par e-mail bientôt.",
          "emailNotFound": "Email introuvable pour effectuer l'exportation. Contactez l'administrateur.",
          "formNotFound": "Formulaire introuvable pour effectuer l'exportation. Contactez l'administrateur.",
          "exportFailed": "Échec de l'exportation du rapport des questionnaires."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Créer un intergroupe pour moi-même",
        "pageTitle": "Créer un intergroupe pour moi-même",
        "form": "Formulaire",
        "infoMessage": " Voici votre cross group par défaut. Ajoutez des employés supplémentaires par lesquels vous souhaitez être évalué. Vous devez en avoir au moins cinq étiquetés du type « cross group ». Votre responsable examinera, mettra à jour en conséquence et publiera les questionnaires.",
        "warningReleasedQuestionnaires": "Vous n'êtes pas en mesure d'ajouter des intergroupes car votre responsable a déjà publié des questionnaires vous concernant. Veuillez discuter avec lui de l'ajout de questionnaires supplémentaires.",
        "add": "Ajouter un employé",
        "evaluatorPerson": "Évaluateur",
        "manager": "Responsable",
        "type": "Type",
        "requestType": "Demandé par",
        "released": "Publié",
        "status": "Statut",
        "actions": "Actions",
        "delete": {
          "title": "Supprimer le questionnaire",
          "text": "Êtes-vous sûr de vouloir supprimer ce questionnaire ?"
        },
        "messages": {
          "alreadyExists": "Ce questionnaire existe déjà pour {names}. Si vous avez des questions, parlez à votre responsable.",
          "addSuccess": "Questionnaires créés avec succès.",
          "deleteSuccess": "Questionnaire supprimé avec succès.",
          "invitedPersonWarning": "{names} a déjà été invité à fournir un feedback 360 sur au moins {limit} autres formulaires. Pour les inclure dans des formulaires supplémentaires, sélectionnez « Enregistrer ». Si leur feedback n'est pas essentiel, fermez sans enregistrer et sélectionnez une autre personne."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Créer des groupes transversaux pour mon équipe",
        "pageTitle": "Créer des groupes transversaux pour mon équipe",
        "form": "Formulaire",
        "manager": "Manager",
        "evaluatedPerson": "Évalué",
        "evaluatorPerson": "Évaluateur",
        "type": "Type",
        "released": "Publié",
        "status": "Statut",
        "loadCrossGroupDefaults": "Charger les paramètres par défaut des groupes transversaux",
        "unloadCrossGroupDefaults": "Décharger les paramètres par défaut des groupes transversaux",
        "releaseQuestionnaire": "Publier les questionnaires",
        "add": "Ajouter un questionnaire",
        "delete": {
          "title": "Supprimer le questionnaire",
          "text": "Êtes-vous sûr de vouloir supprimer ce questionnaire ?"
        },
        "messages": {
          "alreadyExists": "Ce questionnaire existe déjà pour {names}. Si vous avez des questions, veuillez parler à votre responsable.",
          "createdSuccess": "Questionnaires créés avec succès.",
          "deletedSuccess": "Questionnaire supprimé avec succès.",
          "saveError": "Une erreur s'est produite lors de l'enregistrement du questionnaire. Veuillez réessayer.",
          "questionnairesAlreadyExists": "Des questionnaires existent déjà pour : {names}.",
          "managerDisabledMessage": "Vous n'avez pas accès à ce formulaire de groupe transversal",
          "releasedSuccess": "Questionnaires publiés avec succès.",
          "minCrossGroupEvaluations": "Seules les personnes ayant au moins {value} questionnaires de groupe transversal sont affichées.",
          "noQuestionnairesToRelease": "Il n'y a pas de questionnaires à publier. Veuillez ajouter au moins un questionnaire à publier.",
          "isReadOnlyDueStage": "Ce formulaire est en lecture seule et ne peut pas être modifié",
          "remoteInstanceWarning": "Un problème est survenu lors du chargement des informations distantes.",
          "minimumCrossGroupsNotMet": "L'employé n'a pas le nombre minimum de groupes transversaux ({current}/{minimum})",
          "questionnairesReleased": "Questionnaires publiés",
          "readyForRelease": "Prêt à être publié"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "Charger les paramètres par défaut des groupes transversaux",
            "messages": {
              "confirm": "AVERTISSEMENT : Veuillez confirmer que vous souhaitez charger les participants par défaut du groupe transversal pour tous les collaborateurs directs.",
              "success": "Participants par défaut du groupe transversal chargés avec succès."
            }
          },
          "unloadDefaults": {
            "title": "Décharger les paramètres par défaut des groupes transversaux",
            "messages": {
              "confirm": "Veuillez confirmer que vous souhaitez décharger les participants par défaut du groupe transversal pour tous les collaborateurs directs.",
              "success": "Participants par défaut du groupe transversal déchargés avec succès."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Créer des groupes transversaux pour mon équipe distante",
        "pageTitle": "Créer des groupes transversaux pour mon équipe distante"
      },
      "complete": {
        "menuTitle": "Compléter le Questionnaire",
        "pageTitle": "Compléter le Questionnaire",
        "form": "Formulaire",
        "questionnaireType": "Type de Questionnaire",
        "submit": "Soumettre",
        "notApplicable": "N/A",
        "declinedCommentPlaceholder": "Non Applicable",
        "reopen": "Rouvrir",
        "status": {
          "new": "Questionnaire non commencé",
          "inProgress": "Questionnaire en cours",
          "completed": "Questionnaire complété"
        },
        "notApplicableTitle": "Refuser le questionnaire",
        "reopenTitle": "Confirmer le retrait",
        "addFreeEvaluation": "Ajouter une Évaluation Libre",
        "personToEvaluate": "Personne à Évaluer",
        "freeEvaluationWarning": "Les Évaluations Libres devront être approuvées par les managers et ne contribuent pas aux scores globaux du 360.",
        "messages": {
          "loading": "Chargement des questionnaires...",
          "loadingGlobalQuestionnaires": "Chargement des questionnaires globaux...",
          "formNotFound": "Formulaire introuvable.",
          "employeeNotFound": "Employé introuvable.",
          "freeEvaluationNotAllowed": "Vous ne pouvez pas ajouter une évaluation libre pour vous-même, votre responsable, vos pairs ou vos subordonnés directs.",
          "alreadyExists": "Une évaluation pour cette personne existe déjà.",
          "submitConfirmation": "En cliquant sur envoyer, l’évaluation de l’employé affiché est ce qui sera enregistré. Vous pouvez retirer les évaluations soumises jusqu’à ce que le processus 360 passe à la signature du manager.",
          "summaryValidate": "Validez les réponses et faites défiler vers le bas pour soumettre. Cliquer sur le X en haut à droite ne finalisera pas votre soumission.",
          "submitSuccess": "Questionnaire soumis avec succès.",
          "questionnaireNotFound": "Questionnaire introuvable.",
          "notSubmittedWarningMessage": "Ce questionnaire n'a pas encore été soumis et n'est pas pris en compte dans le score de l'employé.",
          "noQuestionnaires": "Vous n'avez aucun questionnaire à compléter.",
          "selectQuestionnaire": "Sélectionnez un questionnaire à compléter.",
          "employeeRateSummary": "Taux de l'employé : ",
          "notApplicable": "Si vous n'êtes pas la personne appropriée pour compléter cette évaluation de performance, vous pouvez décliner la responsabilité, après avoir fourni une raison.",
          "declineSuccess": "Questionnaire refusé avec succès.",
          "requiredQuestionnairesCompleted": "Toutes les évaluations restantes peuvent être complétées à votre discrétion.",
          "allQuestionsRequired": "Toutes les questions et tous les commentaires sont obligatoires pour pouvoir soumettre.",
          "confirmReopen": "Êtes-vous sûr de vouloir retirer l'évaluation de {name} ?",
          "reopenSuccess": "Questionnaire rouvert avec succès.",
          "questionnaireAlreadySubmitted": "Ce questionnaire a déjà été soumis et ne peut pas être modifié.",
          "addFreeEvaluationSuccess": "Évaluation libre ajoutée avec succès."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Examen d'Évaluation Libre",
        "menuTitleGlobal": "Examen Global d'Évaluation Libre",
        "pageTitle": "Examen d'Évaluation Libre",
        "pageTitleGlobal": "Examen Global d'Évaluation Libre",
        "evaluatedPerson": "Évalué",
        "view": "Voir le Questionnaire",
        "infoMessage": "Veuillez examiner les questionnaires ci-dessous et approuver ceux avec lesquels vous êtes d'accord. Si vous n'approuvez pas un questionnaire, aucune action supplémentaire n'est requise.",
        "messages": {
          "confirmApproval": "Êtes-vous sûr de vouloir approuver le questionnaire ?",
          "approvalSuccess": "Questionnaire approuvé avec succès.",
          "notFound": "Questionnaire non trouvé."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Participants au formulaire",
        "pageTitle": "Participants au formulaire",
        "formId": "Formulaire",
        "resetTree": "Reinitialiser l'arborescence",
        "resetTreeTitle": "Reinitialiser l'arborescence",
        "resetTreeText": "Etes-vous sur de vouloir reinitialiser l'arborescence ?",
        "addPerson": "Ajouter un participant",
        "changeManager": "Changer le responsable",
        "downloadTemplate": "Telecharger le modele",
        "import": "Importer",
        "person": "Employe",
        "currentManager": "Responsable actuel",
        "newManager": "Nouveau responsable",
        "messages": {
          "noNodeSelected": "Vous devez selectionner au moins un employe.",
          "saveSuccess": "Participants du formulaire enregistres avec succes.",
          "resetSuccess": "Participants du formulaire reinitialises avec succes.",
          "formNotFound": "Formulaire introuvable.",
          "selectEmployee": "Selectionnez d'abord un employe",
          "addPersonSuccess": "Participant ajoute avec succes.",
          "changeManagerSuccess": "Responsable modifie avec succes.",
          "moveToManagerSuccess": "Personne déplacée vers le nouveau responsable avec succès.",
          "managerNotInTree": "Le responsable sélectionné n'est pas dans l'arbre.",
          "circularManagerSelection": "Impossible de déplacer un employé vers l'un de ses propres subordonnés.",
          "importSuccess": "Fichier importe avec succes. Vous recevrez bientot les resultats par e-mail."
        },
        "errors": {
          "formInExecution": "Cette action ne peut pas etre effectuee car le formulaire est actuellement en cours d'execution."
        }
      },
      "resultViewer": {
        "menuTitle": "Rapports PDF approuves",
        "pageTitle": "Rapports PDF approuves",
        "person": "Personne",
        "personHelpText": "Vous pouvez vous selectionner ou l'un de vos subordonnes directs.",
        "personMultipleInstance": "Ne selectionnez pas d'employes de plusieurs instances. Les resultats peuvent etre incorrects ou incomplets.",
        "manager": "Responsable",
        "form": "Formulaire",
        "position": "Poste",
        "managerFeedback": "Retour du responsable",
        "employeeFeedback": "Retour de l'employe",
        "pdfReport": "Rapport PDF",
        "pdfReportFreeEvaluation": "PDF d'evaluation libre",
        "pdfReportFreeEvaluationNonApproved": "PDF d'evaluation libre non approuve",
        "downloadSelected360Report": "Telecharger le rapport 360 selectionne",
        "downloadSelectedFreeEvaluationReport": "Telecharger le rapport d'evaluation libre selectionne",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Telecharger le rapport d'evaluation libre non approuve selectionne",
        "emailSelected360Report": "Envoyer par e-mail le rapport 360 selectionne",
        "emailSelectedFreeEvaluationReport": "Envoyer par e-mail le rapport d'evaluation libre selectionne",
        "emailSelectedNonApprovedFreeEvaluationReport": "Envoyer par e-mail le rapport d'evaluation libre non approuve selectionne",
        "bulkEmailQueued": "Vos rapports sont en cours de preparation. Vous recevrez sous peu un e-mail avec les pieces jointes PDF.",
        "bulkEmailNoSelection": "Selectionnez au moins une ligne.",
        "bulkEmailInvalidSelection": "Une ou plusieurs lignes selectionnees ne sont pas valides pour votre acces.",
        "bulkEmailNoReportForKind": "Les lignes selectionnees n'incluent pas ce type de rapport.",
        "showFeedback": "Afficher les retours",
        "downloadEvaluationSelectOne": "Selectionnez une personne ou un responsable.",
        "validationSelectPersonOrManager": "Selectionnez une personne ou un responsable pour executer le filtre.",
        "successPdfByEmail": "Le PDF a ete envoye avec succes a votre adresse e-mail."
      },
      "sign": {
        "menuTitle": "Signer les Évaluations",
        "pageTitle": "Signer les Évaluations",
        "menuTitleGlobal": "Signer les Évaluations Globales",
        "pageTitleGlobal": "Signer les Évaluations Globales",
        "form": "Formulaire",
        "managerOrPerson": "Responsable/Personne",
        "person": "Personne",
        "pdfReport": "Rapport PDF",
        "pdfReportFreeEvaluation": "Rapport PDF d'Évaluations Libres",
        "sign": "Signer",
        "signed": "Signé",
        "signTitle": "Signer l'Évaluation",
        "managerSign": "Signature du Responsable",
        "personSign": "Signature de l'employé",
        "signatureComments": "Commentaires de Signature",
        "updateComment": "Mettre à Jour le Commentaire",
        "messages": {
          "signedBy": "Signé par {name} le {date}",
          "signConfirmationManager": "Toute information supplémentaire concernant le processus de commentaires avec votre subordonné peut être fournie ci-dessous.",
          "signConfirmationPerson": "En sélectionnant signer, vous confirmez que vous avez eu une conversation de commentaires avec votre responsable à propos de l'évaluation.",
          "signConfirmationWarning": "En sélectionnant signer, le PDF sera publié à l'employé.",
          "managerSignatureNotAllowed": "Vous ne pouvez pas signer cette évaluation car le responsable l'a déjà signée.",
          "employeeSignatureNotAllowed": "Vous ne pouvez pas signer cette évaluation car la personne l'a déjà signée.",
          "successMessage": "Évaluation signée avec succès.",
          "updateCommentSuccessMessage": "Commentaire mis à jour avec succès.",
          "noComments": "Vous devez fournir des commentaires avant de signer."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Sécurité",
    "resource": {
      "menuName": "Ressource",
      "pageTitle": "Ressource",
      "add": "Ajouter une ressource",
      "edit": "Modifier la ressource",
      "delete": {
        "title": "Supprimer la ressource",
        "text": "Êtes-vous sûr de vouloir supprimer cette ressource ?"
      },
      "id": "Id",
      "name": "Nom",
      "description": "Description",
      "resourceType": "Type de ressource",
      "isActive": "Actif",
      "messages": {
        "created": "Ressource créée avec succès.",
        "updated": "Ressource mise à jour avec succès.",
        "deleted": "Ressource supprimée avec succès.",
        "notFound": "Ressource non trouvée",
        "duplicateName": "Une ressource avec ce nom existe déjà.",
        "inUse": "La ressource est utilisée. Supprimez d'abord ses usages."
      }
    },
    "user": {
      "menuName": "Utilisateur",
      "pageTitle": "Utilisateur",
      "subgridName": "Compte utilisateur",
      "uniqueId": "Id unique",
      "add": "Ajouter un compte utilisateur",
      "edit": "Modifier le compte utilisateur",
      "delete": {
        "title": "Supprimer le compte utilisateur",
        "text": "Êtes-vous sûr de vouloir supprimer ce compte utilisateur ?"
      },
      "personId": "Id",
      "provider": "Fournisseur",
      "userName": "Nom d'utilisateur",
      "isActive": "Actif",
      "messages": {
        "created": "Compte utilisateur créé avec succès.",
        "updated": "Compte utilisateur mis à jour avec succès.",
        "deleted": "Compte utilisateur supprimé avec succès.",
        "notFound": "Compte utilisateur non trouvé",
        "duplicateName": "Ce nom d'utilisateur existe déjà."
      }
    },
    "group": {
      "menuName": "Groupe",
      "pageTitle": "Groupe",
      "add": "Ajouter un groupe",
      "edit": "Modifier le groupe",
      "delete": {
        "title": "Supprimer le groupe ?",
        "text": "Êtes-vous sûr de vouloir supprimer ce groupe ?"
      },
      "id": "Id",
      "name": "Nom",
      "description": "Description",
      "isActive": "Actif",
      "overwriteGroups": "Écraser les groupes",
      "messages": {
        "created": "Groupe créé avec succès.",
        "updated": "Groupe mis à jour avec succès.",
        "deleted": "Groupe supprimé avec succès.",
        "notFound": "Groupe non trouvé",
        "duplicateName": "Un groupe avec ce nom existe déjà.",
        "fileRequired": "Le fichier est requis.",
        "imported": "Les groupes ont été importés correctement"
      }
    },
    "groupPeople": {
      "menuName": "Personnes du groupe",
      "pageTitle": "Personnes du groupe",
      "add": "Ajouter des personnes au groupe",
      "edit": "Modifier les personnes du groupe",
      "delete": {
        "title": "Supprimer les personnes du groupe",
        "text": "Êtes-vous sûr de vouloir supprimer cet enregistrement ?"
      },
      "groupId": "Groupe",
      "personId": "Personne",
      "validityStart": "Début de validité",
      "validityEnd": "Fin de validité",
      "messages": {
        "created": "Personne du groupe créée avec succès.",
        "updated": "Personne du groupe mise à jour avec succès.",
        "deleted": "Personne du groupe supprimée avec succès.",
        "notFound": "Enregistrement non trouvé",
        "alreadyExists": "L'utilisateur utilise déjà ce groupe."
      }
    },
    "groupPermission": {
      "menuName": "Permissions du groupe",
      "pageTitle": "Permissions du groupe",
      "add": "Ajouter une permission de groupe",
      "edit": "Modifier la permission de groupe",
      "delete": {
        "title": "Supprimer la permission de groupe",
        "text": "Êtes-vous sûr de vouloir supprimer cette permission ?"
      },
      "groupId": "Groupe",
      "resourceId": "Ressource",
      "action": "Action",
      "messages": {
        "created": "Permission créée avec succès.",
        "updated": "Permission mise à jour avec succès.",
        "deleted": "Permission supprimée avec succès.",
        "notFound": "Enregistrement non trouvé",
        "duplicateName": "Cette permission pour la ressource existe déjà."
      }
    }
  },
  "goals": {
    "menuName": "Objectifs",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Plans"
    },
    "target": {
      "menuName": "Objectifs",
      "kpiOwner": {
        "menuName": "Objectifs - Propriétaire du KPI"
      }
    },
    "actual": {
      "menuName": "Données réelles",
      "kpiOwner": {
        "menuName": "Données réelles - Propriétaire du KPI"
      }
    },
    "discussionNotes": {
      "menuName": "Notes de Discussion"
    },
    "flexibleGoal": {
      "menuName": "Objectif Flexible"
    },
    "actionPlan": {
      "menuName": "Plan d'Action"
    },
    "library": {
      "menuName": "Bibliothèque"
    },
    "category": {
      "menuName": "Catégorie"
    },
    "PlantArea": {
      "menuName": "Zone d'Usine"
    },
    "clerks": {
      "menuName": "Propriétaires de KPI"
    },
    "quickEntry": {
      "menuName": "Entrée Rapide Annuelle"
    }
  },
  "nineBox": {
    "menuName": "9box",
    "nineBoxForm": {
      "menuName": "Formulaire"
    },
    "nineBoxFormPeople": {
      "menuName": "Participants du Formulaire"
    },
    "fillTalentTalk": {
      "menuName": "Guide Talent Talk"
    },
    "nineBoxCalibration": {
      "menuName": "Calibrage"
    },
    "fillDevelopmentPlan": {
      "menuName": "PDI"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Tableau de Bord"
    },
    "request": {
      "newPCF": {
        "menuName": "Nouveau PCF"
      }
    },
    "requestType": {
      "menuName": "Type de Demande"
    },
    "approvalGroup": {
      "menuName": "Groupe d'Approbation"
    },
    "requestStatuses": {
      "menuName": "Statut de la Demande"
    },
    "catalog": {
      "menuName": "Catalogue"
    },
    "immigrationType": {
      "menuName": "Type d'Immigration"
    }
  },
  "merit": {
    "menuName": "Mérite",
    "meritPlanFormList": {
      "menuName": "Liste des Formulaires"
    },
    "meritDashboard": {
      "menuName": "Tableau de Bord"
    },
    "meritPlan": {
      "menuName": "Plan"
    },
    "awardLetter": {
      "menuName": "Lettre de Récompense"
    },
    "meritPlanParticipants": {
      "menuName": "Participants du Plan de Mérite"
    }
  },
  "bonus": {
    "menuName": "Bonus",
    "bonusIncentiveGroup": {
      "menuName": "Groupe d'Incitation"
    },
    "bonusPlan": {
      "menuName": "Plan"
    },
    "bonusPlanParticipants": {
      "menuName": "Participants du Plan"
    },
    "bonusDashboard": {
      "menuName": "Tableau de Bord"
    },
    "awardLetter": {
      "menuName": "Lettre de Récompense"
    },
    "saipAllocation": {
      "menuName": "Allocation SAIP",
      "messages": {
        "notFound": "Allocation SAIP introuvable.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement de l'Allocation SAIP. Veuillez réessayer.",
        "saveSuccess": "Allocation SAIP enregistrée avec succès.",
        "deleteSuccess": "Allocation SAIP supprimée avec succès.",
        "isInUse": "L'Allocation SAIP est utilisée et ne peut pas être supprimée.",
        "duplicateValueCode": "Les valeurs de l'Allocation SAIP ne peuvent pas avoir de codes en double.",
        "duplicateExternalId": "Une Allocation SAIP avec cet ID externe existe déjà.",
        "valuesSumExceeded": "La somme des valeurs de l'Allocation SAIP ne peut pas dépasser 100 %."
      }
    }
  },
  "cultureTalent": {
    "menuName": "Culture et Talent",
    "culture": {
      "menuName": "Programmes de Culture et Talent"
    },
    "talent": {
      "menuName": "Plateformes de Formation"
    }
  },
  "talentMapping": {
    "menuName": "Cartographie des Talents",
    "skills": {
      "menuName": "Compétences"
    },
    "orgChart": {
      "menuName": "Organigramme"
    },
    "myProfile": {
      "menuName": "Mon Profil"
    },
    "degreeTypes": {
      "menuName": "Type de Diplôme",
      "pageTitle": "Type de Diplôme",
      "name": "Nom",
      "isActive": "Est Actif",
      "add": "Ajouter un Type de Diplôme",
      "edit": "Modifier le Type de Diplôme",
      "delete": {
        "title": "Supprimer le Type de Diplôme",
        "text": "Êtes-vous sûr de vouloir supprimer ce Type de Diplôme ?"
      },
      "messages": {
        "created": "Type de Diplôme créé avec succès.",
        "updated": "Type de Diplôme mis à jour avec succès.",
        "deleted": "Type de Diplôme supprimé avec succès.",
        "saveError": "Une erreur s'est produite lors de l'enregistrement du Type de Diplôme. Veuillez réessayer.",
        "notFound": "Enregistrement Type de Diplôme introuvable.",
        "inUse": "Le Type de Diplôme est en cours d'utilisation et ne peut pas être supprimé."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Demande d'Absence",
    "createRequest": {
      "menuName": "Créer une Demande"
    },
    "viewManageRequests": {
      "menuName": "Mes Demandes"
    },
    "calendar": {
      "menuName": "Calendrier"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Approbations"
    },
    "manageDirectReportsHours": {
      "menuName": "Gérer les Soldes"
    },
    "upload": {
      "menuName": "Télécharger"
    },
    "manageAbsenceProfiles": {
      "menuName": "Gérer les Profils d'Absence"
    },
    "manageHolidays": {
      "menuName": "Gérer les Jours Fériés"
    },
    "hoursCalculationMatrices": {
      "menuName": "Matrices de Calcul des Heures"
    },
    "manageApprovingDelegate": {
      "menuName": "Déléguer les Approbations"
    },
    "notification": {
      "menuName": "Notification d'Absence"
    },
    "manageMatrixCategories": {
      "menuName": "Gérer les Catégories de Matrice"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Gérer la Matrice de Jour Férié Flottant"
    },
    "manageSickMatrix": {
      "menuName": "Gérer la Matrice de Maladie"
    }
  },
  "expenseReport": {
    "menuName": "Rapports de Dépenses",
    "createExpenses": {
      "menuName": "Créer une Dépense"
    },
    "myExpenses": {
      "menuName": "Mes Dépenses"
    },
    "approvals": {
      "menuName": "Dépenses à Approuver"
    },
    "delegateApprovals": {
      "menuName": "Déléguer les Approbations"
    },
    "preparers": {
      "menuName": "Préparateurs"
    },
    "categories": {
      "menuName": "Catégories"
    },
    "distanceRates": {
      "menuName": "Tarifs de Distance"
    },
    "generalLedgers": {
      "menuName": "Livres Généraux"
    },
    "policies": {
      "menuName": "Politiques"
    },
    "projects": {
      "menuName": "Projets"
    }
  },
  "salaryExtraPay": {
    "menuName": "Rémunération Supplémentaire",
    "createRequest": {
      "menuName": "Créer une Demande"
    },
    "myRequests": {
      "menuName": "Mes Demandes"
    },
    "approvals": {
      "menuName": "Approbations"
    },
    "delegateApprovals": {
      "menuName": "Déléguer les Approbations"
    },
    "locationSetups": {
      "menuName": "Configurations de Localisation"
    },
    "export": {
      "menuName": "Exporter"
    },
    "policies": {
      "menuName": "Politiques"
    },
    "payType": {
      "menuName": "Types de Paiement"
    },
    "personnelAreaSetups": {
      "menuName": "Configurations de Zone de Personnel"
    }
  },
  "developmentPlan": {
    "menuName": "Plan de Développement",
    "planDelegate": {
      "menuName": "Déléguer le Plan"
    },
    "questions": {
      "menuName": "Questions"
    },
    "plans": {
      "menuName": "Plans"
    },
    "programs": {
      "menuName": "Programmes"
    },
    "notificationSender": {
      "menuName": "Expéditeur de Notification"
    },
    "fillDevelopmentPlan": {
      "menuName": "PDI"
    },
    "signEvaluations": {
      "menuName": "Signer les Évaluations"
    },
    "resultViewer": {
      "menuName": "Visualiseur de Résultats"
    }
  },
  "survey": {
    "menuName": "Enquête",
    "questionCategories": {
      "menuName": "Catégories de Questions"
    },
    "questions": {
      "menuName": "Questions"
    },
    "ratingScales": {
      "menuName": "Échelles d'Évaluation"
    },
    "actionPlans": {
      "menuName": "Plan d'Action"
    },
    "people": {
      "menuName": "Personnes"
    },
    "surveys": {
      "menuName": "Formulaires d'Enquête"
    },
    "notificationSender": {
      "menuName": "Expéditeur de Notification"
    },
    "dashboard": {
      "menuName": "Tableau de Bord"
    }
  },
  "hourlyPositions": {
    "menuName": "Postes Horaires",
    "createRequest": {
      "menuName": "Créer une Demande"
    },
    "requests": {
      "menuName": "Demandes"
    },
    "employeeSubgroup": {
      "menuName": "Sous-groupe d'Employés"
    },
    "hourlyCatalog": {
      "menuName": "Catalogue Horaire"
    }
  },
  "vuestic": {
    "search": "Rechercher",
    "noOptions": "Éléments non trouvés",
    "ok": "OK",
    "cancel": "Annuler",
    "uploadFile": "Sélectionner un fichier",
    "undo": "Annuler",
    "dropzone": "Déposez les fichiers ici pour les télécharger",
    "fileDeleted": "Fichier supprimé",
    "closeAlert": "fermer l'alerte",
    "backToTop": "retour en haut",
    "toggleDropdown": "basculer le menu déroulant",
    "carousel": "carrousel",
    "goPreviousSlide": "aller à la diapositive précédente",
    "goNextSlide": "aller à la diapositive suivante",
    "goSlide": "aller à la diapositive {index}",
    "slideOf": "diapositive {index} sur {length}",
    "close": "fermer",
    "openColorPicker": "ouvrir le sélecteur de couleur",
    "colorSelection": "sélection de couleur",
    "colorName": "couleur {color}",
    "decreaseCounter": "diminuer le compteur",
    "increaseCounter": "augmenter le compteur",
    "selectAllRows": "sélectionner toutes les lignes",
    "sortColumnBy": "trier la colonne par {name}",
    "selectRowByIndex": "sélectionner la ligne {index}",
    "resetDate": "réinitialiser la date",
    "nextPeriod": "période suivante",
    "switchView": "changer de vue",
    "previousPeriod": "période précédente",
    "removeFile": "supprimer le fichier",
    "reset": "réinitialiser",
    "pagination": "pagination",
    "goToTheFirstPage": "aller à la première page",
    "goToPreviousPage": "aller à la page précédente",
    "goToSpecificPage": "aller à la page {page}",
    "goToSpecificPageInput": "saisir le numéro de page",
    "goNextPage": "aller à la page suivante",
    "goLastPage": "aller à la dernière page",
    "currentRating": "note actuelle {value} sur {max}",
    "voteRating": "voter note {value} sur {max}",
    "optionsFilter": "filtre d'options",
    "splitPanels": "diviser les panneaux",
    "movePaginationLeft": "déplacer la pagination à gauche",
    "movePaginationRight": "déplacer la pagination à droite",
    "resetTime": "réinitialiser l'heure",
    "closeToast": "fermer la notification",
    "selectedOption": "Option sélectionnée",
    "noSelectedOption": "Aucune option sélectionnée",
    "breadcrumbs": "fil d'ariane",
    "counterValue": "valeur du compteur",
    "selectedDate": "date sélectionnée",
    "selectedTime": "heure sélectionnée",
    "progressState": "état du progrès",
    "color": "couleur",
    "next": "Suivant",
    "back": "Retour",
    "finish": "Terminer",
    "step": "étape",
    "progress": "progrès",
    "loading": "Chargement",
    "sliderValue": "La valeur actuelle du curseur est {value}",
    "switch": "Basculer",
    "inputField": "Champ de saisie",
    "fileTypeIncorrect": "Type de fichier incorrect",
    "select": "Sélectionner une option"
  },
  "orgChart": {
    "title": "Organigramme",
    "menuTitle": "Organigramme",
    "menuName": "Organigramme",
    "organization": "Organisation",
    "directReports": "Rapports Directs",
    "showEmployeeDetails": "Afficher les détails de l'employé",
    "goUp": "Monter d'un niveau",
    "navigateHere": "Naviguer ici",
    "vacant": "Vacant",
    "legend": {
      "active": "Actif",
      "inactive": "Inactif",
      "termed": "Résilié",
      "vacant": "Vacant"
    },
    "position": "Poste",
    "plant": "Site",
    "businessArea": "Secteur d'activité",
    "personnelArea": "Zone du personnel",
    "costCenter": "Centre de Coût",
    "hireDate": "Date d'Embauche",
    "score360": "Score 360",
    "scoreGoals": "Score Objectifs",
    "score9box": "9-Box",
    "person": "Personne",
    "employeeType": "Type d'Employé",
    "employeeStatus": "Statut de l'Employé",
    "status": "Statut",
    "view": "Vue",
    "viewOptions": {
      "basic": "Basique",
      "performance": "Performance",
      "headcount": "Effectif"
    },
    "headcount": {
      "directTotal": "Total Direct",
      "directSESNE": "Direct SE/SNE",
      "total": "Effectif Total",
      "spanOfControl": "Étendue du Contrôle",
      "se": "Employés Salariés",
      "sne": "Employés SNE",
      "hourly": "Employés Horaires",
      "truck": "Chauffeurs",
      "work": "Travail"
    },
    "hidePeers": "Masquer les pairs",
    "showPeers": "Afficher le(s) pair(s)",
    "collapse": "Réduire",
    "expand": "Développer",
    "errors": {
      "salariedTypeCannotBeRemoved": "Le type de salarié ne peut pas être supprimé.",
      "employeeNotInTree": "Cet employé est en dehors de l'arborescence du schéma organisationnel et ne peut pas être affiché."
    }
  }
}
